import type { RootScope } from '../types';

import { appealsApi } from '../services/api';

interface ScopeProps {
  /**
   * Custom counter value for testing purposes
   */
  forceCount?: string;

  forceHasNew?: string;
}

export class AppealsCounterController implements ScopeProps {
  static $inject = ['$scope', '$rootScope'];

  count = 0;
  hasNewAppeals = true;

  declare forceCount: string;
  declare forceHasNew: string;

  constructor(
    private $scope: angular.IScope,
    private $rootScope: RootScope,
  ) {
    if (this.forceHasNew) {
      this.hasNewAppeals = this.forceHasNew === 'true';
    }

    if (Number(this.forceCount) >= 0) {
      this.count = Number(this.forceCount);

      return;
    }

    const intervalId = setInterval(() => this.refreshCounters(), 5 * 60 * 1000);

    $scope.$on('$destroy', () => clearInterval(intervalId));

    this.refreshCounters();
  }

  async refreshCounters() {
    // TODO: we could somehow sync/cache with the main appeals component
    // this will give us a possibility to reuse data
    // but we won't win to much so we will skip this for now

    const appeals = await appealsApi.getAll();

    // NOTE: reading user id after request so that scope will have time to populate
    // see `estUserId` directive
    const { user_id: userId } = this.$rootScope;

    const [newCount, underwayCount] = appeals.reduce(
      (acc, appeal) => {
        const assigneeId = appeal.last_action_by || String(appeal.created_by);

        if (assigneeId === userId) {
          if (appeal.status === appealsApi.APPEAL_STATUS.NEW) {
            acc[0]++;
          } else {
            acc[1]++;
          }
        }

        return acc;
      },
      [0, 0],
    );

    this.$scope.$apply(() => {
      this.count = newCount || underwayCount;
      this.hasNewAppeals = newCount > 0;
    });
  }
}
